import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let CLBRegisterController = {

    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/clb-register/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    list: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/clb-register/detail-register`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    listRegister: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/clb-register/list-register`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    delete: (clbId, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/clb-register/delete/${clbId}`,
            method: 'GET',
        }, callback)
    },
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/clb-register/edit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    detail: (clbId, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/clb-register/detail/${clbId}`,
            method: 'GET',
        }, callback)
    },
}

export default CLBRegisterController